module.exports = __webpack_public_path__ + "img/icon-sousuo.ad742c85.svg";